import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorModal from './error-modal/index';
import { authNode, doesPatientOrderExist } from './helpers';
import PageNodeReact from '../survey-node/page-node';
import { useHistory } from '../../helpers/routing';
import './index.scss';

interface Props {
  responses: { [key: string]: any };
  onResponseUpdated: (key: string, val: any) => void;
}

function AuthPage({ onResponseUpdated, responses }: Props) {
  const history = useHistory();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const updateResponse = (answerKey: string, val: boolean | string) => {
    onResponseUpdated(`authPage.${answerKey}`, val);
  };

  return (
    <div className="auth-page" data-testid="auth-page">
      <PageNodeReact
        node={authNode}
        responses={responses.authPage || {}}
        onResponseUpdated={updateResponse}
        gotoNextNode={async () => {
          await doesPatientOrderExist(responses, t, history, setErrorMessage);
        }}
        isResultsPage={false}
        isAuthPage={true}
      />
      {errorMessage !== '' && <ErrorModal errorMessage={t(errorMessage)} onCancel={() => setErrorMessage('')} />}
    </div>
  );
}

export default AuthPage;
